module.exports = __webpack_public_path__ + "img/LEGON.6f119d6e.jpg";